import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
export default function Header() {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuActive, setIsMenuActive] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    i18n.on("languageChanged", (lng) => {
        document.documentElement.lang = lng;
        document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    });

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
        setIsOpen(false);
    };

    const closeMenu = () => {
        setIsMenuActive(false);
    };

    window.addEventListener('scroll', () => {
        const header = document.getElementById('header');
        if (window.scrollY > 50) {
            header.classList.add('bg-white', 'backdrop-blur-[7px]');
        } else {
            header.classList.remove('bg-white', 'backdrop-blur-[7px]');
        }
    });

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        // shadow-[0px_0px_10px_#00000038]
        <header id="header" className="pad-0 fixed py-[10px] w-full flex flex-col z-[100] transition-all duration-300 border-b-[1px] border-b-[#ffffff24]">
            <div className="px-res px-[90px] py-[10px] flex items-center justify-between">
                {/* Logo */}
                <Link to="/">
                    <div className="w-[115px] transition-all duration-300">
                        {scrolled ? (
                            <div className="font-header text-[#0B2C3D] text-[40px] font-bold">{t("Ligasos")}</div>
                        ) : (
                            <div className="font-header text-white text-[40px] font-bold">{t("Ligasos")}</div>
                        )}
                    </div>
                </Link>


                {/* Navigation */}
                <div className="nav-ar flex items-center gap-[50px]">
                    <nav className="hidden md:block">
                        <ul className="flex items-center gap-[10px]">
                            {[
                                { path: "/", label: "Home" },
                                { path: "/about", label: "About us" },
                                { path: "/services", label: "Services" },
                                { path: "/properties", label: "Properties" },
                                { path: "/testimonials", label: "Testimonials" },
                                { path: "/blog", label: "Blog" },
                                { path: "/contact", label: "Contact us" },
                            ].map((item) => (
                                <li className="ml-[5px]" key={item.path}>
                                    <NavLink
                                        to={item.path}
                                        className={({ isActive }) =>
                                            `px-4 py-2 text-[17px] capitalize transition duration-500 ${isActive ? "text-[#B39359]" : scrolled ? "text-black" : "text-white"
                                            } hover:text-[#B39359] font-header` // Apply header font here
                                        }
                                    >
                                        {t(item.label)}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* <div className="d-none w-px h-9 bg-white"></div> */}

                    <div className="flex items-center gap-[10px]">
                        <div className="relative">
                            <button
                                onClick={() => setIsOpen(!isOpen)}
                                className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md capitalize"
                            >
                                <img className="w-[36px] h-[36px]" src={require("../../assets/icons/language.svg").default} alt="Language" />
                            </button>
                            {isOpen && (
                                <div className="absolute right-100 right-0 mt-2 w-40 bg-white shadow-lg rounded-md">
                                    <div className="py-1">
                                        <button
                                            onClick={() => changeLanguage("en")}
                                            className="font-header w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                                        >
                                            English
                                        </button>
                                        <button
                                            onClick={() => changeLanguage("ar")}
                                            className="font-header w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                                        >
                                            العربية
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <Link className="font-header d-none bg-[#B39359] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{t("Call us now")}</Link>
                        <button className={`menu ${isMenuActive ? "active" : ""}`} onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
            {isMenuActive && (
                <nav className="top-[130px] flex flex-col gap-[20px]">
                    <ul className="flex flex-col gap-4">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Home")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("About us")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/services"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Services")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/properties"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Properties")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/testimonials"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Testimonials")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/blog"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Blog")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#B39359] font-bold capitalize" : "text-black"} hover:text-[#B39359] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("contact us")}
                            </NavLink>
                        </li>
                    </ul>
                    <Link className="bg-[#B39359] text-center text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{("Call us now")}</Link>
                </nav>
            )}
        </header>
    );
}